<div class="dialog-content-wrapper">
    <mat-toolbar class='mat-accent m-0 h-56' matDialogTitle fxLayoutAlign="space-between center">
        <span class="title dialog-title" fxLayoutAlign="start center"><mat-icon class="mr-8">account_box</mat-icon> {{titulo}}</span>
        <button *ngIf='puedeCerrarModal' mat-icon-button (click)="matDialogRef.close()" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>
    
    <div mat-dialog-content class="p-16 m-0" fusePerfectScrollbar>
        <mat-card *ngIf='!puedeCerrarModal' class="p-8 mb-8 blue-50 blue-800-fg" fxLayoutAlign='start center'>
            <mat-icon class="mr-8">info</mat-icon>
            Estimado Usuario, esta información es utilizada para realizar los reportes que se envían
            a los organismos de control y la DIAN, por lo tanto, esta información debe estar actualizada.
        </mat-card>

        <app-tercero-registro
            #terceroRegistro
            [accion]="modalAction"
            [terceroId]="terceroId"
            [camposAConfirmar]="camposAConfirmar"
            (onRegistroTercero)="SeRegistroElTercero($event)"
            (onEditarTercero)="SeEditoElTercero($event)">
        </app-tercero-registro>
    </div>

    <div mat-dialog-actions class="px-12 p-0 m-0" fxLayout="row" fxLayoutAlign="space-between center" *ngIf="modalAction != 'detalle'">
        <mat-hint *ngIf="modalAction != 'detalle'">Los campos que tienen el asterico (*) son obligatorios.</mat-hint>
        <button mat-button [disabled]="!puedeGuardarTercero()"  (click)="guardarTercero()" aria-label="SAVE">
            GUARDAR <mat-icon class='ml-8'>save</mat-icon>
        </button>
    </div>
</div>